import React from 'react';
import { View } from 'react-native-web';
import {
  addPathToList,
  Enable_additional_instructions,
  getSubCategoryId,
  manual_amount_layout_title,
  select_package_configuration_key,
  select_package_configuration_text,
  select_package_layout_aligned_text,
  select_package_layout_columns_text,
  select_package_layout_title,
  select_package_paragraph,
  select_package_subtitle,
  select_package_title,
  show_Balance,
} from '../utils/DictionaryManagementUtils';
import SwitcherPanel from '../components/PanelsComponents/Buttons/SwitcherPanel';
import RadioPanelAdvance from '../components/PanelsComponents/Buttons/RadioPanelAdvance';
import FullPagePanel from '../components/PanelsComponents/General/FullPagePanel';
import Title from '../components/PanelsComponents/Text/Title';

const Panel_H08_TopUpSelectPackage = ({
  globJSON,
  selectedScreen,
  onConfigChanged,
  onGotoEdit,
  onStepPressed,
  language,
}) => {
  const editTextList = [
    'select_mobile_package_title',
  ];
  const myScreen = globJSON.screens[selectedScreen];
  const subCategoryId = getSubCategoryId(myScreen);
  const subCategoryIdDefault = getSubCategoryId({ sub_category: myScreen.sub_category, duplication_number: 0 });
  const service = globJSON.configurations.services[subCategoryId];
  const { amount_package } = service;
  const onValueChanged = (key, value) => {
    amount_package[key] = value;
    onConfigChanged();
  };
  return (
    <FullPagePanel
      globJSON={globJSON}
      onConfigChanged={onConfigChanged}
      selectedScreen={selectedScreen}
      onStepPressed={onStepPressed}
      onGotoEdit={onGotoEdit}
      panelHeadline={select_package_title}
      panelSubHeadline={select_package_subtitle}
      editTextList={addPathToList(editTextList, `configurations/services/${subCategoryId}/amount_package/`)}
      editTextListDefault={addPathToList(editTextList, `configurations/services/${subCategoryIdDefault}/amount_package/`)}
      tooltipsTitles={service.screens_ordering}
      paragraph={select_package_paragraph}
      language={language}
    >
      <SwitcherPanel
        text={show_Balance}
        value={amount_package.show_account_balance}
        onValueChanged={(value) => {
          onValueChanged('show_account_balance', value);
        }}
        marginTop={8}
        marginBottom={20}
      />

      <RadioPanelAdvance
        chosenValue={amount_package.package_configuration}
        valuesMap={select_package_configuration_text}
        onValueChanged={(value) => {
          onValueChanged('package_configuration', value);
        }}
      />

      {amount_package.package_configuration !== select_package_configuration_key.manual_amount
      && (
        <View>
          <RadioPanelAdvance
            title={select_package_layout_title}
            chosenValue={amount_package.package_layout_columns}
            valuesMap={select_package_layout_columns_text}
            onValueChanged={(value) => {
              onValueChanged('package_layout_columns', value);
            }}
          />
          <RadioPanelAdvance
            chosenValue={amount_package.package_layout_aligned}
            valuesMap={select_package_layout_aligned_text}
            onValueChanged={(value) => {
              onValueChanged('package_layout_aligned', value);
            }}
          />
        </View>
      )}

      {amount_package.package_configuration !== select_package_configuration_key.packages
      && (
        <View>
          <Title marginBottom={0}>{manual_amount_layout_title}</Title>
          <SwitcherPanel
            text={Enable_additional_instructions}
            value={amount_package.enable_additional_instruction}
            onValueChanged={(value) => {
              onValueChanged('enable_additional_instruction', value);
            }}
            marginTop={8}
            marginBottom={20}
          />
        </View>
      )}

    </FullPagePanel>
  );
};

export default Panel_H08_TopUpSelectPackage;
